import {login, logInWithPassword, setLoginAccount} from "./authActions";


const authMiddleware = (store: any) => (next: (action: any) => void) => (action: any) => {
    if (action.type === logInWithPassword.toString()) {
        store.dispatch(login({email: action.payload.email, password: action.payload.password}));
    }

    if (action.type === login.fulfilled.toString()) {
        store.dispatch(setLoginAccount(action.payload));
    }

    next(action);
};

export default authMiddleware;